import { effect, inject, Injectable } from '@angular/core';
import Intercom, { shutdown } from '@intercom/messenger-js-sdk';
import { AccountService } from '@core/auth';
import { environment } from '@environments/environment';

const INTERCOM_APP_ID = 'iuwzxpbl';

/**
 * Boots the Intercom messenger once the account resolves and shuts it down on
 * logout. JWT-based identity verification uses the `intercomToken` minted by the
 * backend account endpoint. Production only. Bootstrapped at app start via
 * `provideEnvironmentInitializer` in `app.config.ts`.
 */
@Injectable({ providedIn: 'root' })
export class IntercomService {
  private readonly accountService = inject(AccountService);

  private booted = false;

  constructor() {
    if (!environment.production) return;

    effect(() => {
      const profile = this.accountService.profile();

      if (profile) {
        Intercom({
          app_id: INTERCOM_APP_ID,
          region: 'eu',
          name: `${profile.firstName} ${profile.lastName}`,
          intercom_user_jwt: profile.intercomToken,
          alignment: 'right',
          vertical_padding: 20,
          horizontal_padding: 20,
        });
        this.booted = true;
      } else if (this.booted) {
        shutdown();
        this.booted = false;
      }
    });
  }
}
